// ─── Advolve launch config ────────────────────────────────────────────────
// Replace the placeholder values below with your real assets before going live.

// Razorpay payment page URL for the ₹21 slot (every booking button points here)
export const RAZORPAY_URL = "https://rzp.io/rzp/advolve-strategy-meeting";

// Calendly URL visitors are sent to AFTER payment (from the thank-you page)
export const CALENDLY_URL = "https://calendly.com/contact-advolve/1-1-strategy-meeting";

// Meta Pixel ID (base code lives in public/index.html, fires PageView on load)
export const META_PIXEL_ID = "1037947142447711";

// YouTube video ID of the VSL (the part after watch?v=)
export const YOUTUBE_VIDEO_ID = "Pze-BTq2xxU";

// Custom VSL thumbnail (root-relative, served from /public)
export const VSL_THUMBNAIL = "/vsl-thumbnail.jpg";

// Host photo
export const HOST_PHOTO = "/host.jpg";

export const CONTACT_EMAIL = "contact@advolve.co.in";
export const BRAND = "Advolve";
export const HOST_NAME = "Nishant Bhutani";
export const PRICE = "₹21";
